import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CTA_OPTIONS } from "@/data/content";

const pick = (title) => {
  const el = document.querySelector("#contact");
  if (el) el.scrollIntoView({ behavior: "smooth" });
  window.dispatchEvent(new CustomEvent("edc:set-inquiry", { detail: title }));
};

export const CTASection = () => (
  <section id="engage" data-testid="cta-section" className="bg-[#080808] border-y border-white/10">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-28 md:py-40">
      <Reveal className="mb-16 md:mb-20 max-w-3xl">
        <p className="overline text-[#d4af37] mb-6">Ways to Engage</p>
        <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
          Start where it matters most.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
        {CTA_OPTIONS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08} className="h-full">
            <button
              data-testid={`cta-option-${i}`}
              onClick={() => pick(c.title)}
              className="group text-left w-full h-full bg-[#0a0a0a] hover:bg-[#0f0f0f] transition-colors duration-500 p-8 md:p-10 flex flex-col"
            >
              <span className="font-serif text-2xl md:text-3xl text-white group-hover:text-[#d4af37] transition-colors duration-500">
                {c.title}
              </span>
              <span className="mt-4 text-white/55 font-light leading-relaxed flex-1">{c.desc}</span>
              <motion.span
                className="mt-8 inline-flex items-center gap-2 text-[#d4af37] text-xs uppercase tracking-wider"
                whileHover={{ x: 4 }}
              >
                Get Started <ArrowUpRight size={15} />
              </motion.span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
